import { useMemo } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { getFlightItemsView } from 'checkout/selectors/view/flights'

type CollinsonAutoTicketMode = 'DOMESTIC' | 'INTERNATIONAL' | undefined

interface UseCollinsonAutoTicketModeParams {
  provider: string
}

function useCollinsonAutoTicketMode({
  provider,
}: UseCollinsonAutoTicketModeParams): CollinsonAutoTicketMode {
  const flightViewsData = useAppSelector(getFlightItemsView)
  const isCollinson = provider === 'cln'

  return useMemo<CollinsonAutoTicketMode>(() => {
    if (!isCollinson) return undefined
    const { data: flightViews, hasRequiredData } = flightViewsData
    if (!flightViews.length) return undefined
    if (!hasRequiredData) return undefined
    const isInternational = flightViews.some(view =>
      view.flights.some(leg =>
        leg.journeyFlight.flights.some(segment =>
          segment.departingCountry !== segment.arrivalCountry,
        ),
      ),
    )
    return isInternational ? 'INTERNATIONAL' : 'DOMESTIC'
  }, [isCollinson, flightViewsData])
}

export default useCollinsonAutoTicketMode
